import ConfirmationHeader from './ConfirmationHeader'

export default ConfirmationHeader
